import { Link } from "react-router-dom"

export const Buttons = ({ link, children }) => {
    return (
        <section className="flex w-full items-center mb-[10%] justify-between z-10">
            <div className="flex gap-4 items-center">
                <Link to={link} className="outlined-cta">Back</Link>
            </div>
            <div className="flex gap-4 items-center">
                {children}
            </div>
        </section>
    )
}